<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isThanksVisible"
      v-bind="thanks"
      slot="middle"
    />
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <BaseForm
      ref="form"
      v-bind="form"
      novalidate
      class="screen__form"
      @submit="sendTicket"
    />
  </BaseScreen>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import screenMixin from '@/mixins/screen';
import BaseForm from '@/components/BaseForm.vue';
import FieldEmail from '@/components/FieldEmail.vue';

import CONSTANTS from '@/helpers/constants';

const {
  SCREEN_READY,
  ACTION_SEND_TICKET,
} = CONSTANTS;

export default {
  name: 'SendTicketScreen',
  mixins: [screenMixin],
  components: {
    BaseForm,
  },
  data() {
    return {
      email: '',
    };
  },
  computed: {
    ...mapState('cart', [
      'order',
    ]),
    title() {
      return this.$t('titles.email');
    },
    thanks() {
      return {
        icon: {
          name: 'success',
          isSuccess: true,
        },
        title: this.$t('titles.success'),
        text: this.$t('texts.ticketWasSended', { email: this.email }),
        actions: [
          {
            text: this.$t('actions.home'),
            action: () => this.$router.push(this.$router.options.paths.home),
          },
        ],
      };
    },
    error() {
      return {
        title: this.$t('titles.badHardware'),
        text: this.$t('texts.sendTicketsNotPossible'),
        actions: [
          {
            text: this.$t('actions.home'),
            action: () => this.$router.push(this.$router.options.paths.home),
          },
        ],
      };
    },
    form() {
      return {
        fields: [
          {
            id: 'email',
            component: FieldEmail,
          },
        ],
        hasHomeLink: true,
      };
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearAll();
    next();
  },
  mounted() {
    this.initActions();
  },
  methods: {
    ...mapActions('cart', [
      'fetchTicketByOrderId',
      'clearAll',
    ]),
    async sendTicket({ email }) {
      if (this.isPending) return;
      try {
        this.showPending();
        this.email = email;

        const ticketPath = await this.fetchTicketByOrderId(this.order.id);
        const subject = this.$t('titles.yourTickets');
        const body = '';

        this.$robot.mailService.sendMail(email, subject, body, ticketPath);
      } catch (e) {
        console.error(e);
        this.showError();
      }
    },
    setFieldFocus() {
      return this.$refs.form?.setFocus();
    },
    submitForm() {
      return this.$refs.form?.submit();
    },
    initActions() {
      const robotActions = [
        this.$robot.mailService.onSuccess(this.showThanks),
        this.$robot.mailService.onError(this.showError),
      ];
      const rootActions = [
        [SCREEN_READY, this.setFieldFocus],
        [ACTION_SEND_TICKET, this.submitForm],
      ];

      rootActions.forEach((action) => this.$root.$on(...action));

      this.$once('hook:beforeDestroy', () => {
        rootActions.forEach((action) => this.$root.$off(...action));
        robotActions.forEach((unsubscribe) => unsubscribe());
      });
    },
  },
};
</script>
